export default ({ store, redirect }) => {
  const isAuthenticated = store.state.auth.loggedIn
  if (isAuthenticated) {
    return redirect('/')
  }
}
